function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24A12 12 0 0 1 3.515 3.515a12 12 0 1 1 16.97 16.97A11.921 11.921 0 0 1 12 24zM7.15 8.976a.54.54 0 0 0 .05.084.586.586 0 0 1 .114.254L11.2 18h.057l3.767-9.428a6.591 6.591 0 0 0-.055 1.028v6.743a.519.519 0 0 1-.171.4l-1.142 1.086v.057h5.594v-.057l-1.085-1.086a.407.407 0 0 1-.171-.342V7.715a.615.615 0 0 1 .171-.4l1.085-1.258V6h-3.882l-2.911 7.371L9.146 6h-4v.057l1.032 1.429a1.217 1.217 0 0 1 .285.857v6.286a1.824 1.824 0 0 1-.171 1.086L4.75 17.829v.057h4.11v-.057l-1.541-2.057a1.769 1.769 0 0 1-.171-1.085V8.976z"
});

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ea30c70f.svg";
export { ForwardRef as ReactComponent };